














import ExercisesFormTextarea from '@/components/exercises/forms/ExercisesFormTextarea.vue'

export default {
  components: {
    ExercisesFormTextarea,
  },
  props: {
    comments: {
      type: String,
      default: '',
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
}
